import Swal from 'sweetalert2';

$(document).ready(function() {

	var isLoadingNewsletter = false;
    $(document).on('click', '#newsletter-btn, .newsletter-btn', function() {

        if (isLoadingNewsletter) {
            console.log('is loading...');
            return false;
        }

		isLoadingNewsletter = true;

		// scope to the clicked form (the footer renders it for both desktop and mobile)
		var $form = $(this).closest('.footer-newsletter-form');
		var $email = $form.length ? $form.find('.newsletter-email') : $('#newsletter-email');

		var showError = function(text) {
			Swal.fire({
				icon: 'error',
				title: 'Oops...',
				html: text
			});
		};

		var values = {
			email: $email.val(),
			_token: $('meta[name="csrf-token"]').attr('content') || $('#_token_newsletter').val()
		};

		$.ajax({
			type: "POST",
			url: baseURL + "/newsletter/save",
			dataType: "JSON",
			data: values,
			success: function(response) {
				isLoadingNewsletter = false;

				if (response.status == 0) {
					var errors = [];
					for (var errorKey in response.errors) {
						if (!response.errors.hasOwnProperty(errorKey)) continue;
						errors = errors.concat(response.errors[errorKey]);
					}
					showError(errors.join('<br />'));
					return false;
				}

				if (response.status == 1) {
					Swal.fire({
						icon: 'success',
						text: response.message
					});

					$email.val('');

					return false;
				}

				showError(response.message || response.errors || $form.data('error'));
				return false;
			},
			error(error) {
                isLoadingNewsletter = false;
				showError($form.data('error'));
            }
		});

		return false;

    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/newsletter.js